export type SanitizedGql<T> = T extends (infer U)[]
    ? NonNullable<SanitizedGql<U>>[]
    : T extends object
      ? {
            [K in keyof T]-?: K extends 'node' | 'edges'
                ? NonNullable<SanitizedGql<T[K]>>
                : SanitizedGql<T[K]>
        }
      : T

export function sanitizeGql<T>(value: T): SanitizedGql<T>

export function sanitizeGql(value: any): any {
    if (value == null) return value
    if (Array.isArray(value))
        return value.map(sanitizeGql).filter((element: any) => element != null)
    if (typeof value === 'object') {
        const obj: any = {}
        for (const key in value) {
            if (key === 'node' || key === 'edges') {
                // There is a null value for node or edges, parent object
                // is invalid; return null.
                if (value[key] == null) return null
            }
            obj[key] = sanitizeGql(value[key])
        }
        return obj
    }
    return value
}
